import React from 'react';

interface IHoloLensVisorOverlayProps
{
	overlayWidth: number;
	overlayHeight: number;
	verticalOffset: number;
}

const HoloLensVisorOverlay = (props: IHoloLensVisorOverlayProps) => 
{	
	return (
		<div className={"visorOverlayRoot fullScreen centerContent"}>
			<div className={"visorOverlayBox"}
				style={{
					top: `${props.verticalOffset}px`,
					width: `${props.overlayWidth}px`,
					height: `${props.overlayHeight}px`
				}}
			>
				<div className={"visorOverlayLabel"}>
					Visor View
				</div>
			</div>
		</div>
	);
};

export default HoloLensVisorOverlay;